import { ref, reactive, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-441c5c73"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "filter-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "时间段", -1));
const _hoisted_5 = {
  class: "filter-item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "账号", -1));
const _hoisted_7 = {
  class: "filter-item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "外部结算", -1));
const _hoisted_9 = {
  class: "filter-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算币种", -1));
const _hoisted_11 = {
  class: "filter-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "收款状态", -1));
const _hoisted_13 = {
  class: "filter-item btn-group"
};
import dayjs from 'dayjs';
import { STATUS_OPTIONS } from '../types';
import { message } from 'ant-design-vue';
import { getAccountList } from '@/api/billApi';
import { OK, searchFields } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchForm',
  emits: ['search', 'reset', 'tabChange', 'sendAccount'],
  setup(__props, {
    expose,
    emit
  }) {
    const accountSelectRef = ref();
    const accountList = ref([]);
    const defaultPeriod = [dayjs().subtract(2, 'month'), dayjs().subtract(2, 'month')];
    const formState = reactive({
      period: defaultPeriod,
      accountId: [],
      payChnl: 'apple',
      isNeedExternalSettlement: undefined,
      currency: undefined,
      receivedStatus: undefined
    });
    // 限制日期选择范围
    const disabledDate = current => {
      // 不能选择当前月份之后的日期
      return current.isAfter(dayjs(), 'month');
    };
    // 处理日期变化
    const handlePeriodChange = dates => {
      if (!dates) return;
      const [start, end] = dates;
      formState.period = [start, end];
      // 如果时间长度大于12个月，则修改结束时间为12个月
      if (end.diff(start, 'month') > 12) {
        message.warning('时间长度不能超过12个月');
        formState.period[1] = start.clone().add(12, 'month');
      }
    };
    // 获取账号列表
    const queryAccountList = async () => {
      try {
        const res = await getAccountList({
          accountType: 2
        });
        if (res !== null && res !== void 0 && res.data && res.code === OK) {
          var _res$data, _accountSelectRef$val;
          accountList.value = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.list) === null || _res$data === void 0 ? void 0 : _res$data.map(item => {
            var _item$accountId;
            return {
              ...item,
              value: (_item$accountId = item.accountId) === null || _item$accountId === void 0 ? void 0 : _item$accountId.toString(),
              label: item.accountName
            };
          });
          (_accountSelectRef$val = accountSelectRef.value) === null || _accountSelectRef$val === void 0 || _accountSelectRef$val.initializeOptions(accountList.value);
          // 把当前所有账号传给子组件
          emit('sendAccount', accountList.value);
          // 设置默认选中所有账号
          // formState.accountId = accountList.value.map((account: { value: string }) => account.value)
        }
      } catch (error) {}
    };
    const getFormData = () => {
      var _formState$period$, _formState$period$2;
      return {
        startMonthDate: (_formState$period$ = formState.period[0]) === null || _formState$period$ === void 0 ? void 0 : _formState$period$.format('YYYY-MM'),
        endMonthDate: (_formState$period$2 = formState.period[1]) === null || _formState$period$2 === void 0 ? void 0 : _formState$period$2.format('YYYY-MM'),
        accountId: formState.accountId,
        payChnl: 'apple',
        isNeedExternalSettlement: formState.isNeedExternalSettlement,
        currency: formState.currency,
        receivedStatus: formState.receivedStatus
      };
    };
    const handleSearch = () => {
      emit('search');
    };
    const handleReset = () => {
      formState.period = defaultPeriod;
      // 设置默认选中所有账号
      formState.accountId = [];
      formState.payChnl = 'apple';
      formState.isNeedExternalSettlement = undefined;
      formState.currency = undefined;
      formState.receivedStatus = undefined;
      emit('reset');
    };
    onMounted(() => {
      queryAccountList();
      handleSearch();
    });
    expose({
      getFormData
    });
    return (_ctx, _cache) => {
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_range_picker, {
        "allow-clear": false,
        value: formState.period,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.period = $event),
        picker: "month",
        format: "YYYY-MM",
        placeholder: ['开始月份', '结束月份'],
        disabledDate: disabledDate,
        onChange: handlePeriodChange
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_unref(ProductSelect), {
        ref_key: "accountSelectRef",
        ref: accountSelectRef,
        modelValue: formState.accountId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formState.accountId = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 3,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择"
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_select, {
        value: formState.isNeedExternalSettlement,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => formState.isNeedExternalSettlement = $event),
        placeholder: "请选择",
        "allow-clear": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: 1
        }, {
          default: _withCtx(() => [_createTextVNode("是：外部结算账号")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: 0
        }, {
          default: _withCtx(() => [_createTextVNode("否：非外部结算账号")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_a_select, {
        value: formState.currency,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => formState.currency = $event),
        placeholder: "请选择",
        "allow-clear": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "USD"
        }, {
          default: _withCtx(() => [_createTextVNode("USD")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "CNY"
        }, {
          default: _withCtx(() => [_createTextVNode("CNY")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "SGD"
        }, {
          default: _withCtx(() => [_createTextVNode("SGD")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_select, {
        value: formState.receivedStatus,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => formState.receivedStatus = $event),
        placeholder: "请选择",
        "allow-clear": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(STATUS_OPTIONS), (item, key) => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: key,
            value: Number(item.value)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        onClick: handleReset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});